import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TuneIcon from '@mui/icons-material/Tune';

export const BannerInfoSuscripciones = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA', // Color de fondo muy suave
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
                    <Box 
                        sx={{ 
                            width: 52, 
                            height: 52, 
                            borderRadius: '50%', 
                            backgroundColor: '#E8E7FD', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            flexShrink: 0
                        }}
                    >
                        <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                            Gestión de Suscripciones
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                            Administra las suscripciones de los clientes, asignando planes y controlando el uso de créditos y vigencias.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <ListAltIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Asignación de Planes
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Vincula una suscripción a un plan comercial para heredar sus características.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <TuneIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Control de Créditos
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Administra los créditos disponibles y restantes para el consumo de la IA.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
